import { DOAbnormalItemFileBase64Bean } from "./do-abnormal-item-file-base64-bean";
import { DOAbnormalOperationUserBean } from "./do-abnormal-operation-user-bean";

export class DOAbnormalDialogAbnormalItemFileUpdateRequest extends DOAbnormalOperationUserBean {
  abnormalItemSeqNo: number;
  newFiles: DOAbnormalItemFileBase64Bean[];
  deletedAbnormalItemFileDocIds: string[];

  constructor() {
    super();
    this.abnormalItemSeqNo = -1;
    this.newFiles = [];
    this.deletedAbnormalItemFileDocIds = [];
  }
}
